"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableRowOverrides = void 0;
var styles_1 = require("@material-ui/core/styles");
var createMuiTableRowOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            "&$hover:hover": {
                backgroundColor: palette.type === "dark"
                    ? palette.action.hover
                    : styles_1.alpha(palette.common.offBlack, palette.action.selectedOpacity), // contrast 1
            },
            "&$selected, &$selected:hover": {
                backgroundColor: undefined,
            },
            "&$selected": {
                backgroundColor: palette.type === "dark"
                    ? palette.action.selected
                    : styles_1.alpha(palette.common.offBlack, 0.04), // contrast min
            },
        },
    });
};
exports.createMuiTableRowOverrides = createMuiTableRowOverrides;
//# sourceMappingURL=MuiTableRow.js.map